import { render, staticRenderFns } from "./ArticleCat.vue?vue&type=template&id=5976ded4&"
import script from "./ArticleCat.vue?vue&type=script&lang=js&"
export * from "./ArticleCat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports